import React from "react";

type Props = {
  title?: string;
  subtitle?: React.ReactNode;
  centeredSubtitle?: boolean;
};

export default function TransactionCheckoutHeader({
  title,
  subtitle,
  centeredSubtitle,
}: Props) {
  return (
    <>
      <div className="mb-2 mt-1.5 flex flex-col items-center justify-center">
        <div className="font-semibold text-[--color-text-primary]">{title}</div>
        {subtitle ? (
          <div
            className={`text-[--color-text-secondary] text-sm ${centeredSubtitle ? "text-center" : ""}`}
          >
            {subtitle}
          </div>
        ) : null}
      </div>
      <div className="w-full h-px bg-[--color-modal-border] mb-4" />
    </>
  );
}
